import { render, staticRenderFns } from "./windows.vue?vue&type=template&id=3cf6e238&scoped=true"
import script from "./windows.vue?vue&type=script&lang=js"
export * from "./windows.vue?vue&type=script&lang=js"
import style0 from "./index.css?vue&type=style&index=0&id=3cf6e238&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf6e238",
  null
  
)

export default component.exports